import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

function VLSI_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <VLSI_FAQ/>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <VLSI_FAQ/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function VLSI_FAQ(){
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What is VLSI?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Very Large Scale Integration (VLSI) refers to the process of creating integrated circuits (ICs) by combining thousands or even millions of transistors onto a single chip.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What is synthesis in VLSI design?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Synthesis is the process of converting a high-level RTL description of a digital circuit into a gate-level representation using a synthesis tool. This involves mapping the logical design into actual gates and flip-flops.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What is physical design in VLSI?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Physical design involves the placement and routing of the synthesized gates and interconnections on the chip layout, considering factors such as area, power, and timing constraints.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default VLSI_FAQ_page
